module.exports = __webpack_public_path__ + "img/new_logo_by.f91347e7.png";